import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import NoResults from './no-results.png';

interface Props {
  headerText: string;
  supportingText?: string;
  onRetry?: () => void;
}

const EmptyState = ({ headerText, supportingText, onRetry }: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      role="alert"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        background: '#fff',
        borderRadius: '28px',
        height: '100%',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
        <img src={NoResults} data-testid="empty-state-graphic" width={'180px'} height={'118px'} alt="Empty State Graphic" />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
            <Typography variant="h6" color="#00283a" data-testid="empty-state-header">
              {headerText}
            </Typography>
          </Box>
          {supportingText && (
            <Typography variant="body1" data-testid="empty-state-text" sx={{ color: 'primary.light' }}>
              {supportingText}
            </Typography>
          )}
          {onRetry && (
            <Button data-dd-action-name="Reset error boundary" variant="contained" color="primary" onClick={onRetry} sx={{ mt: 2 }}>
              {t('try_again')}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EmptyState;
